import * as React from "react";
import { Heading as Heading$1 } from "@grandvisionhq/elements";
import { compose } from "@grandvisionhq/utils";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withHidableContent } from "../../../../hocs/hocs/with-hidable-content.js";
import { withBloomreachData } from "../../../../hocs/hocs/with-bloomreach-data.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
const variantMap = {
  h1: "large",
  h2: "medium",
  h3: "small",
  h4: "smallest",
  h5: "subheading1",
  h6: "subheading2"
};
const CmsHeading = ({ meta: { title, type, alignment } }) => /* @__PURE__ */ React.createElement(Heading$1, { className: `heading heading--${alignment}`, variant: variantMap[type], align: alignment }, title);
const Heading = compose(
  withBreakpointVisibility,
  withHidableContent,
  withBloomreachData,
  withAnchor
)(CmsHeading);
export {
  CmsHeading,
  Heading as default
};
//# sourceMappingURL=Heading.js.map
